import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    message, Dropdown, Menu, List, Alert
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import { CaretRightOutlined, LinkOutlined, DownOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'
import View from './view.js'
import Jiechu from "./jiechu";


const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {
                order: store.getState().data.info.order_1 ? store.getState().data.info.order_1 : 1
            },
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/hetong', ['首页', '合同管理', '租赁合同'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, { [name]: dateString })
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, { current: page, pagesize: pagesize })
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, { current: 1, pagesize: old.pagesize })
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Contract/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    status_react: data.status_react ? data.status_react : [],
                    yq_react: data.yq_react ? data.yq_react : [],
                    order_react: data.order_react ? data.order_react : [],
                    cncost_fd_react: data.cncost_fd_react ? data.cncost_fd_react : [],
                    czwt_react: data.czwt_react ? data.czwt_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    delSel() {
        let that = this
        fetch('/Contract/allsave', {
            method: "POST", body: JSON.stringify({
                id: this.state.selectedRowKeys,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    /*解除*/
    Zuofei() {
        let that = this
        fetch('/Contract/allsave', {
            method: "POST", body: JSON.stringify({
                id: this.state.selectedRowKeys,
                edit: 2
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.getdata()
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                id: that.state.selectedRowKeys
            }
        }
        arr.download = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Contract/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }

                that.setState({
                    downloading: false
                })
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = data.url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                } catch (e) {
                    alert("下载异常！");
                }
            })
    }

    onOrderChange = (name, value, e) => {
        let that = this
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
        setTimeout(() => {
            that.getdata(1)
        })
        let user_info = store.getState().data.info
        // console.log(user_info)
        user_info.order_1 = value
        // console.log(user_info)
        that.props.SET_INFO(user_info)
    }

    arrorder(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Menu.Item key={index}><a onClick={this.onOrderChange.bind(this, 'order', item.id)}
                    style={{ color: this.state.newcondition.order == item.id ? '#40a9ff' : '#333' }}>{item.name}</a></Menu.Item>
            )
        }
    }

    render() {
        const menu = (
            <Menu>
                {this.arrorder(this.state.order_react)}
            </Menu>
        );
        const columns = [
            {
                title: '合同编号',
                dataIndex: 'ref',
                key: 'ref',
                width: 100,
                fixed: 'left',
                render: (row, record) => {
                    return (<Space direction={"vertical"}>
                        <View id={record.id} title={row} refresh={this.getdata.bind(this)} />
                        {record.czwt == 1 ? <Tag color={'red'}>存在问题</Tag> : null}
                    </Space>)
                },
            }, {
                title: '企业名称',
                dataIndex: 'company_name',
                key: 'company_name',
                // width:200,
                render: (row, record) => {
                    return (<>
                        <div>{row}</div>
                        {record.aliasname ? <div style={{ color: 'grey' }}>曾用名：{record.aliasname}</div> : null}
                    </>)
                },
            }, {
                title: '所属园区',
                dataIndex: 'yq_id',
                key: 'yq_id',
                width: 110,
            }, {
                title: '租赁房间',
                dataIndex: 'room',
                key: 'room',
                width: 200,
            }, {
                title: '租赁面积',
                dataIndex: 'area',
                key: 'area',
                width: 120,
            }, {
                title: '租赁时间',
                dataIndex: 'zltime',
                key: 'zltime',
                width: 220,
                render: (row, record) => {
                    return (<>
                        <div>{row}</div>
                        {record.pay_remark && record.pay_remark.length ?
                            <List
                                size={'small'}
                                header={null}
                                footer={null}
                                // bordered
                                dataSource={record.pay_remark ? record.pay_remark : []}
                                renderItem={(item) => (
                                    <div style={{ color: 'orange' }}>
                                        <CaretRightOutlined /> {item}
                                    </div>
                                )}
                            />
                            : null}
                    </>)
                },
            }, {
                title: '租赁时长',
                dataIndex: 'duration',
                key: 'duration',
                width: 100,
            }, {
                title: '解除时间',
                dataIndex: 'jctime',
                key: 'jctime',
                width: 150,
                render: (row, record) => {
                    return (<Space>
                        {row}
                        {record.status == 3 ? <Jiechu title={<EditOutlined />} id={record.id} jctime={row} refresh={this.getdata.bind(this)} /> : null}
                    </Space>)
                },
            }, {
                title: '免租期月数',
                dataIndex: 'mz_duration',
                key: 'mz_duration',
                width: 110,
            }, {
                title: '正常期月数',
                dataIndex: 'zc_duration',
                key: 'zc_duration',
                width: 110,
            }, {
                title: '月度应收租赁费',
                dataIndex: 'rent',
                key: 'rent',
                width: 140,
            }, {
                title: '月度应收管理服务费',
                dataIndex: 'service',
                key: 'service',
                width: 160,
            }, {
                title: '采暖费',
                dataIndex: 'cncost',
                key: 'cncost',
                width: 150,
                render: (row, record) => {
                    return (<>
                        <div>{row} {record.cncost_fd_text ? `【${record.cncost_fd_text}】` : null}</div>
                    </>)
                },
            }, {
                title: '制冷费',
                dataIndex: 'zlcost',
                key: 'zlcost',
                width: 100,
            }, {
                title: '保证金',
                dataIndex: 'guarantee',
                key: 'guarantee',
                width: 120,
            }, {
                title: '装修保证金',
                dataIndex: 'zx_guarantee',
                key: 'zx_guarantee',
                width: 130,
            }, {
                title: '添加人',
                dataIndex: 'aid',
                key: 'aid',
                width: 100,
            }, {
                title: '合同状态',
                dataIndex: 'status_text',
                key: 'status_text',
                width: 100,
                fixed: 'right',
                render: (row, record) => {
                    return (<>
                        {record.status == 1 && <Tag color={'green'}>{row}</Tag>}
                        {record.status == 2 && <Tag color={'red'}>{row}</Tag>}
                        {record.status == 3 && <Tag color={'grey'}>{row}</Tag>}
                    </>)
                },
            }, {
                title: <Dropdown overlay={menu}>
                    <Space>排序<DownOutlined /></Space>
                </Dropdown>,
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 150,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <View id={record.id} refresh={this.getdata.bind(this)} />
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('1') ?
                                <Edit refresh={this.getdata.bind(this)} id={record.id} />
                                : null) : null}
                            {record.status == 3 ? null : <Jiechu title={'解除'} id={record.id} refresh={this.getdata.bind(this)} />}
                        </Space>
                    </>)
                },
            },]
        const { tableloading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Alert message={<div dangerouslySetInnerHTML={{
                __html: `
                1、查询2026年<span style="color:orange">新签的</span>租赁合同，租赁开始时间区间选择2026-01-01至2026-12-31；<br/>
                2、查询2026年<span style="color:orange">到期的</span>租赁合同，租赁结束时间区间选择2026-01-01至2026-12-31；<br/>
                3、查询2026年<span style="color:orange">期间的</span>租赁合同，租赁开始时间（第二个）选择2026-12-31，租赁结束时间（第一个）选择2026-01-01；
            `}}></div>} type="info" style={{ marginBottom: 16 }} />
            <Row justify="space-between" align="top" gutter={[0, 15]} style={{ marginBottom: 15 }}>
                <Space wrap>
                    <Input className="input" placeholder="合同编号/企业名称"
                        value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                        onChange={this.onChange.bind(this, 'keywords')} autoComplete="off" />
                    <Select placeholder="所属园区"
                        style={{ width: 120 }}
                        value={this.state.newcondition.yq_id ? this.state.newcondition.yq_id : null}
                        onChange={this.onSelChange.bind(this, 'yq_id')} allowClear>
                        {this.arrsel(this.state.yq_react)}
                    </Select>
                    {/*<RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'stime')}
                                 value={[(this.state.newcondition.stime1 ? moment(this.state.newcondition.stime1) : null), (this.state.newcondition.stime2 ? moment(this.state.newcondition.stime2) : null)]}
                                 placeholder={['租赁时间', '租赁时间']}/>*/}
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'stime')}
                        value={[(this.state.newcondition.stime1 ? moment(this.state.newcondition.stime1) : null), (this.state.newcondition.stime2 ? moment(this.state.newcondition.stime2) : null)]}
                        placeholder={['租赁开始时间', '租赁开始时间']} />
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'etime')}
                        value={[(this.state.newcondition.etime1 ? moment(this.state.newcondition.etime1) : null), (this.state.newcondition.etime2 ? moment(this.state.newcondition.etime2) : null)]}
                        placeholder={['租赁结束时间', '租赁结束时间']} />
                    <Select placeholder="是否存在问题"
                        style={{ width: 150 }}
                        value={this.state.newcondition.czwt ? this.state.newcondition.czwt : null}
                        onChange={this.onSelChange.bind(this, 'czwt')} allowClear showSearch
                        optionFilterProp="children">
                        {this.arrsel(this.state.czwt_react)}
                    </Select>
                    <Select placeholder="是否浮动"
                        style={{ width: 120 }}
                        value={this.state.newcondition.cncost_fd ? this.state.newcondition.cncost_fd : null}
                        onChange={this.onSelChange.bind(this, 'cncost_fd')} allowClear showSearch
                        optionFilterProp="children">
                        {this.arrsel(this.state.cncost_fd_react)}
                    </Select>
                    <Select placeholder="合同状态"
                        style={{ width: 120 }}
                        value={this.state.newcondition.status ? this.state.newcondition.status : null}
                        onChange={this.onSelChange.bind(this, 'status')} allowClear showSearch
                        optionFilterProp="children">
                        {this.arrsel(this.state.status_react)}
                    </Select>
                    <Input className="input" placeholder="添加人"
                        value={this.state.newcondition.keyword ? this.state.newcondition.keyword : null}
                        onChange={this.onChange.bind(this, 'keyword')} autoComplete="off" />
                    <Button type="primary" icon={<SearchOutlined />}
                        onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined />} className='huise'
                        onClick={this.reset.bind(this)}>重置</Button>
                    {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('1') ?
                        <Edit refresh={this.getdata.bind(this)} />
                        : null) : null}
                </Space>

            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                scroll={{ x: 2650 }}
                style={{ marginBottom: 20 }}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('1') ?
                                <>
                                    <Popconfirm
                                        title="确认删除?"
                                        onConfirm={() => this.delSel()}
                                        okText="确认"
                                        cancelText="取消"
                                    >
                                        <Button type="primary" danger>删除</Button>
                                    </Popconfirm>
                                    {/*<Popconfirm
                                        title="确认解除?"
                                        onConfirm={() => this.Zuofei()}
                                        okText="确认"
                                        cancelText="取消"
                                    >
                                        <Button type="primary" danger>解除</Button>
                                    </Popconfirm>*/}
                                </>
                                : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('1') ?
                                <Button type="primary"
                                    onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('1') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                    current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                    pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                    total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                    showTotal={total => `共 ${total} 条数据`} />
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname} />
